import React from 'react'
import ReactDOM from 'react-dom/client'
import { App, AuthWrapper } from './components'
import { SettingsProvider, ToastProvider, SessionProvider } from './context'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SettingsProvider>
      <ToastProvider>
        <AuthWrapper> 
        <SessionProvider>
          <App />
        </SessionProvider>
        </AuthWrapper>
      </ToastProvider>
    </SettingsProvider>
  </React.StrictMode>
)
